import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { OrgProvider } from "./contexts/OrgContext";

// Registers Highcharts modules before the first chart is created (see HighchartsModules.ts)
import "./constants/HighchartsModules";

import App from "./containers/App/App";
import { CookiesProvider } from "react-cookie";
// //store
import { Provider } from "react-redux";
import { store } from "./redux/store";

import "mapbox.js/dist/mapbox.css";

import "./sass/css/bootstrap-multiselect.css";
import "sprflat/assets/plugins/misc/highlight/styles/default.css";

import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "vis-timeline/dist/vis-timeline-graph2d.min.css";
import "@popperjs/core";

// import "select2";

import "./sass/bootstrap.scss";

import CustomErrorBoundary from "@containers/errors/ErrorFallback";

if (import.meta.hot) {
  import.meta.hot.accept();
}

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);

  root.render(
    <CookiesProvider>
      <Provider store={store}>
        <Router>
          <OrgProvider>
            <CustomErrorBoundary>
              <App />
            </CustomErrorBoundary>
          </OrgProvider>
        </Router>
      </Provider>
    </CookiesProvider>
  );
}
